const formatIntegerString = (value, maxLength) => {
  return (value || "").replace(/[^0-9]/g, "").substring(0, maxLength);
};

export { formatIntegerString };
